import { Resolve } from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { tap } from "rxjs/operators";
import { PricesService } from "../prices/prices.service";
import { Prices } from "../../shared/prices/prices";

@Injectable({
    providedIn: "root",
})
export class PricesResolver implements Resolve<Observable<Prices>> {
    private prices_: Prices;

    constructor(private pricesService: PricesService) {}

    resolve() {
        if (!this.prices_) {
            return this.pricesService
                .getPrices()
                .pipe(tap(prices => (prices = this.prices_)));
        }
        return of(this.prices_);
    }
}
